// src/features/auth/signup/hooks/useStores.ts

import {
  useEffect,
  useState,
} from 'react';

import { signupService } from '../services/signupService';

import type {
  StoreListItem,
} from '../types/signup.types';

import {
  extractStoreList,
  getErrorMessage,
} from '../utils/signup.utils';

export const useStores = () => {
  const [
    storeList,
    setStoreList,
  ] = useState<StoreListItem[]>(
    [],
  );

  const [
    isLoadingStores,
    setIsLoadingStores,
  ] = useState(true);

  const [
    storeErrorMessage,
    setStoreErrorMessage,
  ] = useState('');

  useEffect(() => {
    let mounted = true;

    const loadStores =
      async (): Promise<void> => {
        try {
          setIsLoadingStores(true);

          setStoreErrorMessage('');

          const response =
            await signupService.getStores();

          if (!mounted) {
            return;
          }

          const stores =
            extractStoreList(
              response.data,
            ).filter(
              (store) =>
                store.storeId > 0,
            );

          setStoreList(stores);

          if (
            stores.length === 0
          ) {
            setStoreErrorMessage(
              '선택할 수 있는 매장이 없습니다.',
            );
          }
        } catch (
          error: unknown
        ) {
          if (!mounted) {
            return;
          }

          setStoreList([]);

          setStoreErrorMessage(
            getErrorMessage(
              error,
              '매장 목록을 불러오지 못했습니다.',
            ),
          );
        } finally {
          if (mounted) {
            setIsLoadingStores(
              false,
            );
          }
        }
      };

    void loadStores();

    return () => {
      mounted = false;
    };
  }, []);

  return {
    storeList,
    isLoadingStores,
    storeErrorMessage,
  };
};